
import { defineComponent } from 'vue'
import { HakoInput, ISelectOption } from '@hakosalo/hakolib'
import axios from 'axios'
import IGuideDto from '@/interfaces/IGuideDto'
export default defineComponent({
	components: {
		HakoInput
	},
	props: [
		'chosencategoryprop',
		'categoriesprop',
		'chosenguideprop',
	],
	setup(props) {
		props.chosencategoryprop
		props.categoriesprop
	},
	mounted() {
		this.mapCategories();
		this.setGuide();
	},
	data() {
		return {
			guide: {
				id: null as number|null,
				name: '' as string,
				roleId: null as null | number,
				category: {} as ISelectOption<number>,
				published: false as boolean,
				order: null as null|number,
			},
			categories: [] as ISelectOption<number>[]
		}
	},
	methods: {
		newCategory() {
			this.$emit('new-category')
		},
		saveGuide() {
			if(this.guide.name.length < 2) {
				this.$alert.alert('Tarkista kentät', 'Nimi tulee olla ainakin 2 merkkiä')
				return;
			}
			if(!this.guide.category.value) {
				this.$alert.alert('Valitse kategoria.', 'Kategoriaa ei löydy jostain syystä');
				return;
			}
			let ord = null;
			if (this.guide.order && this.guide.order > 0) {
				ord = this.guide.order
			}
			let payload = {
				id: this.guide.id,
				name: this.guide.name,
				published: this.guide.published,
				categoryId: this.guide.category.value,
				order: ord,
			} as IGuideDto
			if(!payload.id) {
				axios.post('Guide/NewGuide', payload).then(resp => {
					this.$emit('new-guide', resp.data)
					console.log(resp.data);
				})
				.catch(err => {
					console.log(err)
				})
			}
			else {
				axios.post('Guide/EditGuide', payload).then(resp => {
					this.$emit('new-guide');
					console.log(resp.data);
				})
				.catch(err => console.log(err))
			}
		},
		setGuide() {
			if(this.chosenguideprop) {
				this.guide.id = this.chosenguideprop.id;
				this.guide.published = this.chosenguideprop.published;
				this.guide.name = this.chosenguideprop.name;
				this.guide.order = this.chosenguideprop.order;
			}
		},
		mapCategories() {
			this.categories = []
			this.categoriesprop?.forEach((parentObj: any) => {
				let topCategory = {
					text: parentObj.name,
					value: parentObj.id,
					children: []
				} as ISelectOption<number>
				this.categories.push(topCategory);
				if (parentObj.children) {
					parentObj.children.forEach((child: any) => {
						let option = {
							value: child.id,
							text: "- "+child.name,
							children: []
						} as ISelectOption<number>
						this.categories.push(option)
					})
				}
			})
			this.guide.category = {
				text: this.chosencategoryprop.name,
				value: this.chosencategoryprop.id
			}
		}
	}
})
